import React, { Component } from "react";
import Select from "react-select";
import { connect } from 'react-redux';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import {
  PURCHASE_ORDERS_URL
} from '../../../../actions/url';
import { InputField } from '../../inputField';
import Spinner from '../../../../components/Widgets/spinner';
import GenericSelection from '../../GenericSelection';

//{{url}}v1/purchase/split_purchase_order/{purchase_order_id}


const splitPOAPI = (data, PurchaseOrder_id, success, failed) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/purchase/split_purchase_order/${PurchaseOrder_id}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    alert('SUCCESS!')
    success();
  }).catch(err => {
    failed();
    if (err.data) {
      alert(JSON.stringify(err.data))
    } else {
      alert(JSON.stringify(err));
    }
  });
}

function getVendors(companyid, success) {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/vendor/?Company_id=${companyid}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    success(res.data);
  }).catch(res => {
    alert(JSON.stringify(res.data));
  })
}


function fetchPurchaseOrderDetailsAPI(pk, success) {
  axios.get(
    `${PURCHASE_ORDERS_URL}detail` + `/${pk}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      success(response.data);
    }, (err) => {

    });;
}

const modalStyle = {
  width: '800px',
  height: '700px',
  marginLeft: '-20%',
  marginTop: '-320px',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class SplitPO extends Component {
  state = {
    isLoading: false,
    rows: [],
    filters: {},
    vendors: [],
    selectedVendor: '',
  }

  componentDidMount() {
    getVendors(this.props.selectedCompany.value, this.setVendorState);
    fetchPurchaseOrderDetailsAPI(this.props.selectedRows[0].PurchaseOrder_id, (data) => {
      this.setState({ rows: data.map(row => ({
        ...row,
        split_unit_price: row.OrderUnitPrice,
      })) })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedCompany !== this.props.selectedCompany) {
      getVendors(this.props.selectedCompany.value, this.setVendorState)
    }
  }

  handleSplitClick = () => {
    this.setState({ isLoading: true });
    const rows = this.state.rows.filter(row => row.split_qty && row.split_unit_price);
    const split_purchase_order_lines = rows.map(row => ({
      purchase_order_line_id: row.PurchaseOrderLine_id,
      split_qty: parseInt(row.split_qty),
      split_unit_price: parseFloat(row.split_unit_price),
    }));
    const data = {
      split_purchase_order_lines,
      split_vendor_id: this.state.selectedVendor.value,
    }
    splitPOAPI(data, this.props.selectedRows[0].PurchaseOrder_id, () => {
      this.setState({ isLoading: false })
      this.props.handleSplitPOSuccess()
    }, () => {
      this.setState({ isLoading: false })
    });
  }
  setVendorState = (data) => this.setState({ vendors: data.map(vendor => ({ label: vendor.Name, value: vendor.Vendor_id })) });

  renderSplitPOTable = () => {
    // if (this.props.isLoading) return <Spinner />;

    // Parameters of the react-data-grid

    const tableHeight = 450;

    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const onClearFilters = () => {
      // all filters removed
      // const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: {} };
      this.setState({ filters: {} });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      // const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: newFilters };
      this.setState({ filters: newFilters });
    };
    
    const handleRowUpdated = ({ cellKey, key, rowIdx, updated}) => {
      const rows = [...this.state.rows];
      rows[rowIdx] = {
        ...rows[rowIdx],
        ...updated,
      }
      this.setState({
        rows,
      })
    }

    // Column definition
    let columns = [{
      key: 'ProductNum',
      name: <Translate value="product_num" />,
      resizable: true,
      sortable: true,
      width: 100,
    },
    {
      key: 'Name',
      name: <Translate value="product_name" />,
      resizable: true,
      sortable: true,
      width: 250,
    },
    {
      key: 'OrderQuantity',
      name: <Translate value="order_qty" />,
      resizable: true,
      width: 70,
      sortable: true,
    },
    {
      key: 'OrderUnitPrice',
      name: <Translate value="order_unit_dollarsign" />,
      resizable: true,
      width: 110,
      sortable: true,
    },
    {
      key: 'split_qty',
      name: <Translate value="split_qty" />,
      resizable: true,
      width: 70,
      editable: true,
    },
    {
      key: 'split_unit_price',
      name: <Translate value="split_unit_price$" />,
      resizable: true,
      width: 110,
      editable: true,
    },
    ]

    return (<ReactDataGrid
      enableCellSelect
      headerRowHeight={45}
      onGridSort={handleGridSort}
      onAddFilter={handleFilterChange}
      onClearFilters={onClearFilters}
      columns={columns}
      rowGetter={rowGetter}
      rowsCount={getSize()}
      rowHeight={25}
      minHeight={tableHeight}
      onRowUpdated={handleRowUpdated}
    />)
  }
  render() {
    return (
      <form style={styles.container} id="receive-merge-modal">
        <div style={{ width: '100%', textAlign: 'center', height: '550px', fontSize: '15px', fontWeight: 'bold' }}>
          <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', margin: '20px' }}>
            <div style={{ margin: '5px' }}><Translate value="select_vendor" />:</div>
            <div style={{ margin: '5px' }}>
              <div className="customer-sales">
                <GenericSelection
                  options={this.state.vendors}
                  value={this.state.selectedVendor}
                  setSelected={(e) => {
                    this.setState({ selectedVendor: e })
                  }}
                />
              </div>
            </div>
          </div>
          {this.renderSplitPOTable()}
        </div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.onClose()
            }}
          >
            <Translate value="cancel" />
          </Button>
          {this.state.isLoading && <Spinner />}
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            disabled={this.state.isLoading}
            onClick={() => {
              this.handleSplitClick()
            }}
          >
            <Translate value="split" />
          </Button>

        </div>
      </form>
    )
  }
}

const SplitPOModal = ({ isVisible, onClose, onConfirm, selectedRows, handleSplitPOSuccess, selectedCompany }) => (
  <SkyLightStateless
    title={'Split PO'}
    onCloseClicked={onClose}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <SplitPO selectedRows={selectedRows} onClose={onClose} onConfirm={onConfirm} handleSplitPOSuccess={handleSplitPOSuccess} selectedCompany={selectedCompany} />
  </SkyLightStateless>
)

const mapState = state => ({
  selectedCompany: state.header.selectedCompany,
});

SplitPOModal.propTypes = propTypes
SplitPOModal.defaultProps = defaultProps

export default connect(mapState, {

})(SplitPOModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/purchaseManagement/SplitPOModal.jsx